import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { input } from '@angular/core';
import { LoanCard } from '../../../models/loan.model';
import { NavigationService } from '../../../services/navigation.service';

/**
 * Component that displays a summary of loan information in a card format
 */
@Component({
  selector: 'app-loan-card',
  templateUrl: './loan-card.component.html',
  styleUrl: './loan-card.component.scss',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    RouterLink
  ]
})
export class LoanCardComponent {
  readonly #navigationService = inject(NavigationService);
  readonly loan = input.required<LoanCard>();

  /**
   * Handle view details click - close mobile sidenav when navigating
   */
  onViewDetailsClick(): void {
    this.#navigationService.closeMobileNav();
  }
}
